// test2048
(2048 && 0);
